import styled from 'styled-components';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const PreviewSection = styled.section`
  margin: 0;
  color: ${({ theme }) => theme.colors.black_9};
  font-size: 14px;
  padding: ${({ embedded }) => (embedded ? '0' : '0 42px')};
  margin-top: 5px;
  margin-bottom: 40px;
`;

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const QuestionWrapper = styled.div``;

export const Question = styled.div`
  display: flex;
  margin-top: 20px;

  > div {
    width: 100%;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const SubmitPanel = styled.div`
  align-items: center;
  height: 60px;
  min-height: 60px;
  justify-content: center;
  padding: 0 30px;
  background: ${({ theme }) => theme.colors.white};
  bottom: 80px;
  border-top: 1px solid ${({ theme }) => theme.colors.black_1};
  position: sticky;
  z-index: 2;
  display: flex;
  flex-direction: column;
  margin-top: auto;

  button:not(.reset) {
    font-weight: bold;
    border: 2px solid ${({ theme }) => theme.colors.buttonGreenFront};
    background-color: ${({ theme }) => theme.colors.buttonGreenFront};
    color: ${({ theme }) => theme.colors.black};
    transition:
      background-color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      color 0.2s ease-in-out;

    &:hover:not([disabled]),
    &:focus:not([disabled]) {
      border-color: ${({ theme }) => theme.colors.black};
      background-color: ${({ theme }) => theme.colors.buttonGreenFront};
      color: ${({ theme }) => theme.colors.black};
      transition:
        background-color 0.2s ease-in-out,
        border-color 0.2s ease-in-out,
        color 0.2s ease-in-out;
    }
  }

  .lp--teacherPanel & {
    bottom: 60px;

    > div {
      justify-content: flex-end;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChecklistWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.behaviorBlue};
  border-radius: 11px;
  margin-bottom: 24px;
  margin-top: 30px;
`;

export const ChecklistHeader = styled.div`
  height: 58px;
  width: 100%;
  border-radius: 10px 10px 0px 0px;
  background-color: ${({ theme }) => theme.colors.behaviorBlue};
  display: flex;
  align-items: center;

  h2 {
    margin: 0px 0px 0px 19px;
    font-size: 18px;
    font-weight: bold;
    font-style: italic;
  }
`;

export const ChecklistBody = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;

  > div {
    margin-top: 5px;
  }

  .quill .ql-container.ql-bubble p {
    margin: 0;
  }

  [disabled] {
    opacity: 0.5;
  }
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin: 15px 0 25px;

  > div {
    margin-left: 10px;
  }
`;

export const Alternatives = styled.div`
  font-size: 14px;
`;

export const AlternativeWrapper = styled.div`
  margin: 20px 0;
  padding: 0 22px;
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Alternative = styled.div`
  display: flex;
  flex-direction: column;

  p:last-of-type {
    margin: 0;
  }
`;

export const AlternativeOption = styled.button`
  background-size: 24px 24px;
  background-color: ${({ theme }) => theme.colors.transparent};
  border: 3px solid ${({ theme, selected }) => (selected ? theme.colors.transparent : theme.colors.slateGrey)};
  border-radius: 50%;
  display: inline-block;
  height: 24px;
  width: 24px;
  transition: ${({ selected }) => (!selected ? 'none' : 'border-color 0.2s ease-in-out')};
  background-image: ${({ selected }) =>
    selected ? 'url(/assets/images/1.1/panels/editor/quiz/green-checkmark.svg)' : 'none'};
  background-repeat: no-repeat;
  background-position: center;
  cursor: ${({ selected, disabled }) => (selected || disabled ? 'default' : 'pointer')};
  margin-left: 10px;
  flex-shrink: 0;

  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    border-color: ${({ theme, selected }) => (selected ? theme.colors.transparent : theme.colors.menuButtonBorder)};
    transition: ${({ selected }) => (selected ? 'none' : 'border-color 0.2s ease-in-out')};
  }

  &.error {
    background-image: ${({ selected }) =>
      selected ? 'url(/assets/images/1.1/panels/editor/quiz/red-cross.svg)' : 'none'};
    background-color: ${({ theme }) => theme.colors.errorFlash};
  }

  &.correct {
    background-image: none;
    border-color: ${({ theme }) => theme.colors.menuButtonBorder};
    background-color: ${({ theme }) => theme.colors.buttonGreenFront};
  }
`;

export const InfoPanel = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const PreviewBottomPanel = styled(SubmitPanel)`
  bottom: 140px;
  padding: 20px 42px;
  font-style: italic;
  opacity: 1;
  color: ${({ theme }) => theme.colors.black_7};
  height: initial;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.behaviorGreenBack};
  font-size: 15px;

  > div {
    background-color: ${({ theme }) => theme.colors.greyBorder};
    border-radius: 20px;
    height: 11px;
    margin-left: 11px;
    position: relative;
    width: 71px;
  }
`;

export const ProgressPanel = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const Glossary = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 10px;
`;

export const GlossaryHeader = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 18px;
  margin: 0 -10px;
`;

export const GlossaryBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  p {
    margin: 0 !important;
  }

  ~ div {
    margin-left: -10px;
  }
`;

export const GlossaryRow = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme, even }) => (even ? theme.colors.transparent : theme.colors.black_1)};
  margin: 0 -10px;
`;

export const GlossaryConcept = styled.div`
  display: flex;
  width: 30%;
  font-weight: bold;
  margin: 10px;
  line-height: 20px;
`;

export const GlossaryDescription = styled.div`
  display: flex;
  align-items: center;
  width: 70%;
  margin: 10px;
  padding-left: 10px;
  line-height: 20px;

  &.correct::before {
    background: url(/assets/images/1.1/panels/editor/quiz/green-checkmark.svg) no-repeat;
    background-size: contain;
    content: '';
    padding-right: 30px;
    height: 20px;
    width: 20px;
  }

  &.error::before {
    background: url(/assets/images/1.1/panels/editor/quiz/red-cross.svg) no-repeat;
    background-size: contain;
    content: '';
    padding-right: 30px;
    height: 20px;
    width: 20px;
  }
`;

export const QuizInfo = styled.div`
  font-style: italic;
  margin: 10px 0;
  font-weight: bold;
`;

export const ResultInfo = styled.div`
  margin: 20px 10px;
`;

export const GlossarySelector = styled.button`
  display: flex;
  align-items: center;
  width: 70%;
  border: none;
  outline: none;
  background-color: ${({ theme }) => theme.colors.transparent};
  transition: background-color 0.2s ease-in-out;
  padding: 10px;
  text-align: left;
  line-height: 20px;

  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    background-color: ${({ theme }) => theme.colors.organizationGreen};
    transition: background-color 0.2s ease-in-out;
  }

  &.correct::before {
    background: url(/assets/images/1.1/panels/editor/quiz/green-checkmark.svg) no-repeat;
    background-size: contain;
    content: '';
    padding-right: 30px;
    height: 20px;
    width: 20px;
  }

  &.error::before {
    background: url(/assets/images/1.1/panels/editor/quiz/red-cross.svg) no-repeat;
    background-size: contain;
    content: '';
    padding-right: 30px;
    height: 20px;
    width: 20px;
  }
`;
